import { z } from 'zod';
import { tradeSchema } from './job.js';
export const verificationStatusSchema = z.enum([
    'NOT_REQUIRED', // e.g. work permit for a South African citizen
    'MISSING', // never submitted
    'PENDING', // submitted, awaiting ops review
    'VERIFIED',
    'REJECTED',
    'EXPIRED', // re-checked every 12 months
]);
export const verificationDocumentTypeSchema = z.enum([
    'ID', // SA ID, matched to the bank account name
    'WORK_PERMIT', // non-citizens only
    'POLICE_CLEARANCE', // SAPS certificate, under 12 months old
    'CIPC', // company registration + director check
]);
export const VERIFICATION_DOCUMENT_LABEL = {
    ID: 'ID verification',
    WORK_PERMIT: 'Work permit',
    POLICE_CLEARANCE: 'Police clearance',
    CIPC: 'CIPC registration',
};
export const artisanAvailabilitySchema = z.enum(['AVAILABLE', 'ON_A_JOB', 'OFF_DUTY']);
export const artisanStandingSchema = z.enum([
    'ACTIVE',
    'WARNED', // first cash-bypass offence
    'SUSPENDED', // second offence
    'REMOVED', // third offence
]);
/**
 * South African mobile number in E.164. The WhatsApp bot keys conversations off this,
 * and artisans log in with it, so a single canonical format is not optional.
 */
export const saMobileSchema = z
    .string()
    .trim()
    .regex(/^\+27[6-8]\d{8}$/, 'Must be a South African mobile number in +27 format');
export const artisanSummarySchema = z.object({
    id: z.string().uuid(),
    firstName: z.string().min(1),
    lastName: z.string().min(1),
    trade: tradeSchema,
    suburbs: z.array(z.string().min(1)),
    rating: z.number().min(0).max(5),
    completedJobs: z.number().int().nonnegative(),
    availability: artisanAvailabilitySchema,
    standing: artisanStandingSchema,
});
/**
 * What a customer is allowed to see about an artisan BEFORE payment clears.
 *
 * First name only. No surname, no mobile number. Enforced here as a type so that a
 * controller cannot accidentally serialise the full record into a pre-payment response.
 */
export const artisanPublicSchema = z.object({
    firstName: z.string().min(1),
    trade: tradeSchema,
    rating: z.number().min(0).max(5),
    completedJobs: z.number().int().nonnegative(),
});
//# sourceMappingURL=artisan.js.map